const TransformModifierKeys = ['isHiddenRoot', 'isMovableParent', 'isMovableInverter'];

function restoreFastHierarchyMap({ assets: { objects: allObjects }, hierarchy, slides }, fastMap) {
    if (typeof hierarchy[0] === "number") hierarchy.shift();

    const slideCount = slides.length;

    fastMap.root = { children: [] };

    function fromSlideFlag(flag) {
        const deleted = (flag & 0x001) !== 0;
        const visible = (flag & 0x010) !== 0;
        const inSlide = (flag & 0x100) !== 0;

        return { deleted, visible, inSlide };
    }

    function restore(objects, parent) {
        objects.forEach(object => {
            if (typeof object === "string") object = { uuid: object };
            if (!("slides" in object)) object.slides = {};
            if (!("children" in object)) object.children = [];

            const objectData = allObjects[object.uuid];
            const dst = {
                uuid: object.uuid,
                name: objectData.name,
                slides: new Array(slideCount),
                children: []
            };

            let prevFlag = dst.slides[0] = fromSlideFlag("0" in object.slides ? object.slides[0] : 0);

            for (let i = 1; i < slideCount; i++) {
                if (i in object.slides) prevFlag = fromSlideFlag(object.slides[i]);

                dst.slides[i] = prevFlag;
            }

            for (const key of TransformModifierKeys) {
                if (key in objectData) dst[key] = objectData[key];
            }
            if ("isFullyDeleted" in object) dst.isFullyDeleted = object.isFullyDeleted;

            parent.push(dst);
            fastMap[object.uuid] = dst;

            restore(object.children, dst.children);
        });
    }

    restore(hierarchy, fastMap.root.children);

    return fastMap;
}

export default restoreFastHierarchyMap;
export { restoreFastHierarchyMap };